import { NavLink } from 'react-router-dom';
import type { SidebarPageConfig } from '@/config/pages';
import styles from './SidebarNavItem.module.css';

interface SidebarNavItemProps {
  page: SidebarPageConfig;
  badge?: number;
}

export function SidebarNavItem({ page, badge }: SidebarNavItemProps) {
  const Icon = page.sidebar.icon;

  return (
    <NavLink
      to={page.path}
      className={({ isActive }) =>
        `${styles.navItem} ${isActive ? styles.active : ''}`
      }
      aria-current="page"
    >
      <span className={styles.iconWrap}>
        <Icon className={styles.icon} />
        {badge != null && badge > 0 && (
          <span className={styles.badge}>{badge}</span>
        )}
      </span>
      <span className={styles.label}>{page.title}</span>
    </NavLink>
  );
}
